import React from "react";
import "./Footer.css";

export default function footer() {
  return (
    <div className="footer-container">
      <div className="footer-parent">
        <img
          src="https://i.postimg.cc/PxrwRg14/shape-bg.png"
          alt="errorsss"
        />
      </div>
    </div>
  );
}
